import { c as _c } from "react/compiler-runtime";
import { useMarkets } from "@opensea/app-kit";
import { Satellite } from "@opensea/ui-kit/icons";
import { CheckboxFilterContentAvatar, CheckboxFilterContentItem, CheckboxFilterContentItemCheckbox, CheckboxFilterContentItemContent, CheckboxFilterContentItemTitle } from "./CheckboxFilterContent";
export function MarketplaceCheckboxFilterContent(t0) {
  const $ = _c(20);
  const {
    market,
    name,
    checked,
    onClick,
    children
  } = t0;
  const {
    getMarketName,
    getLogo
  } = useMarkets();
  let t1;
  if ($[0] !== checked) {
    t1 = <CheckboxFilterContentItemCheckbox checked={checked} />;
    $[0] = checked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getLogo || $[3] !== market) {
    t2 = getLogo(market).icon || Satellite;
    $[2] = getLogo;
    $[3] = market;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <CheckboxFilterContentAvatar className="ml-1 translate-y-[-0.5px]" icon={t2} />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== getMarketName || $[8] !== market || $[9] !== name) {
    t4 = name ?? getMarketName(market);
    $[7] = getMarketName;
    $[8] = market;
    $[9] = name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <CheckboxFilterContentItemContent><CheckboxFilterContentItemTitle>{t4}</CheckboxFilterContentItemTitle></CheckboxFilterContentItemContent>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children || $[14] !== market || $[15] !== onClick || $[16] !== t1 || $[17] !== t3 || $[18] !== t5) {
    t6 = <CheckboxFilterContentItem className="gap-2" key={market} onClick={onClick}>{t1}{t3}{t5}{children}</CheckboxFilterContentItem>;
    $[13] = children;
    $[14] = market;
    $[15] = onClick;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}